<template>
    <div class="mamMasterSubscripting">
        <div class="el-table-outer">
          <el-table
            :data="listData"
            v-loading="loading"
            :empty-text="$t('root.noData')"
            class="mam-master-subscrinpting-el-table"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
          >
            <div class="table-nodata" slot="empty">
              {{$t('root.noData')}}
            </div>
            <el-table-column
              type="selection"
              key="1"
              :selectable="selectable"
            >
            </el-table-column>
            <el-table-column
              :label="$t('client')"
              key="2"
              min-width="160px"
            >
              <template slot-scope="scope">
                <div>{{scope.row.alias}}</div>
                <span class="font999">{{scope.row.login}}</span>
              </template>
            </el-table-column>
            <el-table-column
              key="3"
              prop="balance"
              :label="$t('User.commissionBanlance')"
              sortable
            >
            </el-table-column>
            <!--            <el-table-column
                                key="4"
                                prop="managementAmount"
                                :label="$t('Manage_funds')"
                                sortable
                                min-width="100px"
                        >
                        </el-table-column>-->
            <el-table-column
              key="5"
              prop="login"
              :label="$t('Allocation')"
              min-width="120px"
            >
              <template slot-scope="scope">
                <template>
                  <div>{{getStrategy(scope.row, self)}}</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              key="6"
              prop="copyNum"
              :label="$t('Current_follow')"
              sortable
              min-width="120px"
            >
              <template slot-scope="scope">
                {{scope.row.copyNum}}{{$t('transactions')}}
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div class="" slot="content">
                    {{$t('Maximum_follow_number')}}{{scope.row.copyMaxNum}}{{$t('transactions')}}
                  </div>
                  <el-progress
                    v-if="scope.row.copyMaxNum"
                    :format="format"
                    :percentage="getPercentage(scope.row)"
                    :color="getProgressColor(scope.row)"
                  ></el-progress>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              key="7"
              prop="copyLots"
              :label="$t('Current_follow_lot')"
              min-width="120px"
            >
              <template slot-scope="scope">
                {{scope.row.copyLots}}{{$t('Home.forexLot')}}
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div class="" slot="content">
                    {{$t('Maximum_follow_lot')}}{{scope.row.copyMaxLots	}}{{$t('Home.forexLot')}}
                  </div>
                  <el-progress
                    v-if="scope.row.copyMaxLots"
                    :format="format"
                    :percentage="getPercentageLots(scope.row)"
                    :color="getProgressColorLots(scope.row)"
                  ></el-progress>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              key="8"
              prop="statProfit"
              :label="$t('Subscription_revenue')"
              sortable
              min-width="100px"
            >
              <template slot-scope="scope">
                    <span :class="{
                        'theme-color':   isIncludeMinus(scope.row.statProfit) == true,
                        'theme-green':   isIncludeMinus(scope.row.statProfit) == false,
                    }">{{scope.row.statProfit}}</span>
              </template>
            </el-table-column>
            <el-table-column
              key="9"
              prop="subDays"
              :label="$t('Subscription_days')"
              sortable
              min-width="100px"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div class="" slot="content">
                    {{scope.row.beginDate}}-
                  </div>
                  <span>{{scope.row.subDays}} {{$t('day')}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              key="10"
              prop="amount"
              :label="$t('Automatic_renewal')"
            >
              <template slot-scope="scope">
                <span>{{scope.row.isRenew === 1 ? $t('Yes'): $t('Not')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              key="11"
              prop=""
              :label="$t('Follow_the_order')"
            >
              <template slot-scope="scope">
                <div class="icon-dot"
                     :class="{on: scope.row.copyStatus == 1}"
                ></div>
                <span
                  class="follow-order"
                  :class="{on: scope.row.copyStatus == 1}"
                >{{getFollowText(scope.row.copyStatus)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              key="12"
              :label="$t('Trade.oper')"
            >
              <template slot-scope="scope">
                <span class="pointer" @click="followSettingHandle(scope.row)">{{$t('Follow_the_set')}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-outer" v-if="total">
          <div class="paginnation-left">
            <size-change @sizeChange="sizeChange"></size-change>
            <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
          </div>
          <vs-pagination
            class="pagination-box"
            :max="max"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { parseTime } from '@/utils/index'
  import { getStrategy,isIncludeMinus } from '@/utils/common';
  import initData from '@/mixins/initData';
  export default {
    name: 'index',
    mixins: [initData],
    data() {
      return {
        statistics:{
          profitSum: '',
        },
        self: {}
      };
    },
    created(){
      this.self = this;
      this.$nextTick(() => {
        this.init();
      })
    },
    computed: {
      ...mapGetters(['copyingSelectData','listRefresh']),
    },
    watch:{
      listRefresh(){
        this.init()
      },
    },
    methods: {
      parseTime,
      getStrategy,
      isIncludeMinus,
      beforeInit(){
        this.params = {
          mtId: this.$route.params.mtid,
          page: this.page -1,
          size: this.size,
        }
        if(this.sort){
          this.params.sort = this.sort;
        }
        this.url = '/crm/reception/querySubscribing';
        return true;
      },
      selectable(row,index){
        if(row.authorization == 0){
          return false;
        }else {
          return true;
        }
      },
      getStatusMinWidth(){
        if(this.language == 'en_US'){
          return '150px';
        }else {
          return '';
        }
      },
      getPercentage(row){
        return (row.copyNum / row.copyMaxNum) * 100;
      },
      getProgressColor(row){
        if(this.getPercentage(row) <= 50){
          return '#11AC80'
        }else if(this.getPercentage(row) > 50 && this.getPercentage(row) < 100){
          return '#FF8102'
        }else if(this.getPercentage(row) == 100){
          return '#E44F47'
        }
      },
      getPercentageLots(row){
        return (row.copyLots / row.copyMaxLots) * 100;
      },
      getProgressColorLots(row){
        if(this.getPercentageLots(row) <= 50){
          return '#11AC80'
        }else if(this.getPercentageLots(row) > 50 && this.getPercentageLots(row) < 100){
          return '#FF8102'
        }else if(this.getPercentageLots(row) == 100){
          return '#E44F47'
        }
      },
      format(){
        return '';
      },
      getFollowText(copyStatus){
        return copyStatus ? this.$t('Turned_on'): this.$t('closed')
      },
      followSettingHandle(row){
        this.$store.commit('setMasterAccountEditSubscrpitDialogType', 'mam');
        this.$store.commit('setCurrentMasterMtId', this.$route.params.mtid);

        this.$store.commit('setCopyingSelectMultiple', false);
        this.$store.commit('setMasterAccountEditSubscrpitParams', row);
        this.$store.commit('setCopyingSelectData', [{
          alias: row.alias,
          id: row.id,
          login: row.login,
          managementAmount: row.managementAmount,
          copyLeverage: row.copyLeverage,
        }]);
        this.$store.commit('setMasterAccountEditSubscrpitDialogShow', true);
      },
      handleSelectionChange(val) {
        this.$store.commit('setMasterAccountEditSubscrpitDialogType', 'mam');
        this.$store.commit('setCopyingSelectMultiple', true);
        if(val.length == 1){
          this.$store.commit('setMasterAccountEditSubscrpitParams', val[0]);
        }else {
          let defaultEditSubscrpitParams = {
            copyType: 1,
            copyValue: '',
            copyMaxNum: '',
            copyMaxLots: '',
            copyStatus: 1,
            isRenew: 1,
          };
          this.$store.commit('setMasterAccountEditSubscrpitParams', defaultEditSubscrpitParams);
          this.$store.commit('setCopyingSelectData', val);
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../../assets/scss/variable";
.mamMasterSubscripting {
  .el-table-outer {
    overflow-x: auto;
    /deep/ .mam-master-subscrinpting-el-table {
      min-width: 1200px;
    }
  }
    .icon-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: $themeColor;
        border-radius: 50%;
        &.on {
            background-color: $themeGreen;
        }
    }
    .follow-order {
        color: $themeColor;
        &.on {
            color: $themeGreen;
        }
    }
}
</style>
